import { createApi } from "@reduxjs/toolkit/query/react";
import { marketPlaceBaseQueryWrapper } from "@/utils/rtkHelper";

export interface BrokerSearch {
  startAt: number;
  pageSize: number;
  sortDesc: boolean;
  company_id: string;
  vendor_id: number;
  filter_groups: any[];
}

export interface BrokerSearchResult {
  items: Broker[];
  pageSize: number;
  startAt: number;
  sortDesc: boolean;
  total: number;
}

interface Broker {
  id: number;
  first_name: string;
  last_name: string;
  phone: string;
  id_proof_type: string;
  id_proof_number: string;
  percentage: number;
}

export const brokerApi = createApi({
  reducerPath: "brokerApi",
  baseQuery: marketPlaceBaseQueryWrapper,
  tagTypes: ["broker"],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getBrokerByVendorId: builder.query<any, any>({
      query: ({ id }) => `/broker/vendors/${id}`,
      providesTags: ["broker"],
    }),

    getBroker: builder.query({
      query: () => `/broker`,
      providesTags: ["broker"],
    }),

    getBrokerById: builder.query<any, any>({
      query: ({ id }) => `/broker/${id}`,
      providesTags: ["broker"],
    }),

    searchBrokers: builder.query<BrokerSearchResult, BrokerSearch>({
      query: (input) => ({
        url: `/broker/search`,
        method: "POST",
        body: input,
      }),
      providesTags: ["broker"],
    }),

    createBroker: builder.mutation<void, any>({
      query: (input) => ({
        url: `/broker`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["broker"],
    }),

    updateBroker: builder.mutation<void, { id: number; data: any }>({
      query: ({ id, data }) => ({
        url: `/broker/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["broker"],
    }),
    uploadFile: builder.mutation({
      query: (formData) => ({
        url: `/broker/document`,
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["broker"],
    }),
    deleteBroker: builder.mutation<void, any>({
      query: (id) => ({
        url: `/broker/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["broker"],
    }),
  }),
});

export const {
  useGetBrokerByIdQuery,
  useSearchBrokersQuery,
  useCreateBrokerMutation,
  useUpdateBrokerMutation,
  useDeleteBrokerMutation,
  useUploadFileMutation,
  useGetBrokerByVendorIdQuery,
  useGetBrokerQuery,
} = brokerApi;
